const EXTENDED_FILE_NAME_PATTERN = /filename\*\s*=\s*[^']*'[^']*'([^;]+)/i;
const FILE_NAME_PATTERN = /filename\s*=\s*(?:"([^"]*)"|([^;]+))/i;

const decodeExtendedValue = (value) => {
  try {
    return decodeURIComponent(value.trim());
  } catch {
    return '';
  }
};

export const getContentDispositionFileName = (header) => {
  if (!header) {
    return '';
  }

  const extendedMatch = header.match(EXTENDED_FILE_NAME_PATTERN);
  const extendedFileName = extendedMatch ? decodeExtendedValue(extendedMatch[1]) : '';

  if (extendedFileName) {
    return extendedFileName;
  }

  const match = header.match(FILE_NAME_PATTERN);

  return match ? (match[1] ?? match[2]).trim() : '';
};
